export const PUBLIC_TEST_CATEGORIES = [
  { id: 'all', labelKey: 'portal.category_all' },
  { id: 'dtm', labelKey: 'portal.category_dtm' },
  { id: 'attestation', labelKey: 'portal.category_attestation' },
  { id: 'milliy-sertifikat', labelKey: 'portal.category_milliy_sertifikat' },
  { id: 'ielts', labelKey: 'portal.category_ielts' },
  { id: 'sat', labelKey: 'portal.category_sat' },
  { id: 'general', labelKey: 'portal.category_general' },
  { id: 'languages', labelKey: 'portal.category_languages' },
] as const;

export type PublicTestCategory = (typeof PUBLIC_TEST_CATEGORIES)[number]['id'];

export const CATEGORY_ALIASES: Record<string, string> = {
  'umumiy-fanlar': 'general',
  'umumiy': 'general',
  'maktab': 'general',
  'boshqa-tillar': 'languages',
  'tillar': 'languages',
  'chet-tili': 'languages',
  'foreign-languages': 'languages',
  'attestatsiya': 'attestation',
  'pedagog': 'attestation',
  'otm': 'dtm',
  'milliysertifikat': 'milliy-sertifikat',
  'milliy': 'milliy-sertifikat',
  'milliy_sertifikat': 'milliy-sertifikat',
};

export const normalizeCategorySlug = (category?: string | null): string => {
  if (!category) return 'all';
  const lower = category.toLowerCase().trim();
  return CATEGORY_ALIASES[lower] || lower;
};

export const publicTestCategoryPath = (category: string) =>
  category === 'all' ? '/portal/tests' : `/portal/tests?category=${category}`;

